import type { Result } from '@tessa-lean/base';
import type {
  GitDiffQuery,
  GitDiffResponse,
  GitOverviewResponse,
  GitRepositoryLink,
} from '@tessa-lean/base/api-schemas/index.js';

import { apiCall, type ApiContext, type ApiError } from '../client.js';

export async function getOverview(
  ctx: ApiContext,
): Promise<Result<GitOverviewResponse, ApiError>> {
  return apiCall<undefined, GitOverviewResponse>(ctx, 'GET', '/api/v1/git/overview');
}

export async function getDiff(
  ctx: ApiContext,
  query: GitDiffQuery = {},
): Promise<Result<GitDiffResponse, ApiError>> {
  const params = new URLSearchParams();
  if (query.base !== undefined && query.base.length > 0) params.set('base', query.base);
  if (query.target !== undefined && query.target.length > 0) params.set('target', query.target);
  const suffix = params.size > 0 ? `?${params.toString()}` : '';
  return apiCall<undefined, GitDiffResponse>(ctx, 'GET', `/api/v1/git/diff${suffix}`);
}

export async function saveRepositoryLink(
  ctx: ApiContext,
  url: string | null,
): Promise<Result<GitRepositoryLink, ApiError>> {
  return apiCall<GitRepositoryLink, GitRepositoryLink>(ctx, 'PUT', '/api/v1/git/repository-link', {
    url,
  });
}

export const gitApi = { getOverview, getDiff, saveRepositoryLink };
